function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWafynetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "48.696px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 40 48.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#46a5e5",
    d: "M23.892 0.042q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#44a9eb",
    d: "M20.662 -0.042h1.077a24 24 0 0 1 1.905 0.248q-0.211 0.003 -0.331 0.166 -0.126 -0.157 -0.373 -0.166 -2.866 -0.275 -5.673 0.373a55.6 55.6 0 0 0 -2.816 0.87q1.463 -0.674 3.064 -1.035 -0.148 -0.081 0 -0.124 0.118 0.06 0.248 0.083a34 34 0 0 1 2.898 -0.414"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#2a9af5",
    d: "M23.644 0.207a20.8 20.8 0 0 1 1.491 0.166 16.8 16.8 0 0 1 3.313 1.16h-0.248q-0.096 2.179 -1.449 3.892 -0.986 1.112 -2.195 1.946a39.6 39.6 0 0 1 -3.727 1.905 73.2 73.2 0 0 0 -9.275 3.727q-2.595 1.255 -4.555 3.354 -1.284 1.408 -2.07 3.147 -0.253 0.212 -0.248 0.58 -0.211 0.016 -0.373 0.166a0.32 0.32 0 0 1 -0.166 -0.083q0.007 -0.566 -0.083 -1.16 -0.27 -0.345 -0.124 0.042a0.96 0.96 0 0 0 -0.124 0.29l-0.083 -0.166a1.08 1.08 0 0 0 -0.042 0.414Q3.6 18.915 3.52 18.22a385.6 385.6 0 0 1 0.166 -2.029q-0.02 0.416 0.042 0.828 0.068 -0.456 0.124 -0.911 1.425 -3.767 4.555 -6.336a36.8 36.8 0 0 1 3.478 -2.319 167.2 167.2 0 0 1 6.294 -3.147 29.08 29.08 0 0 0 3.892 -2.567q0.696 -0.633 1.242 -1.366 0.12 -0.162 0.331 -0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#44a1e3",
    d: "M25.134 0.29q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#44a2e5",
    d: "M25.383 0.29q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#439fe6",
    d: "M26.294 0.538q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#50b4ef",
    d: "M13.54 1.615q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#49aae7",
    d: "M29.358 1.78q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#3da0e8",
    d: "M28.613 1.615a4.16 4.16 0 0 1 0.745 0.248 3.4 3.4 0 0 1 0.58 0.414 7.44 7.44 0 0 1 -1.325 -0.662"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#42b6f8",
    d: "M28.447 1.532q0.123 -0.021 0.166 0.083a7.44 7.44 0 0 0 1.325 0.662l0.331 0.083q0.042 0.104 0.166 0.083l0.497 0.414q0.203 0.266 0.497 0.414 -0.054 -0.008 -0.083 0.042 0.421 0.375 0.456 0.952a78.4 78.4 0 0 1 0.207 2.319q-0.766 3.871 -4.141 5.921a21.2 21.2 0 0 1 -2.733 1.408 185.2 185.2 0 0 1 -8.778 2.733q-3.815 1.141 -6.874 3.644a6 6 0 0 0 -0.58 0.621q-0.098 -0.035 -0.166 -0.124 0.325 -0.194 0.662 -0.58l-0.248 -0.248 0.166 -0.083 -0.248 -0.414q0.381 0.06 0.497 -0.373 0.167 0.105 0.248 0.29 0.122 0.073 0.166 -0.083 -0.059 -0.212 -0.042 -0.456 -0.081 0.148 -0.124 0a0.6 0.6 0 0 1 0.166 -0.207q-0.218 -0.192 -0.414 -0.207 0.188 -0.169 0.373 -0.083 0.108 -0.076 0.124 -0.207a1.36 1.36 0 0 1 -0.166 -0.373q0.037 -0.314 0.042 -0.662 0.126 -0.141 0.166 0.083l0.083 -0.166q0.089 0.118 0.207 0.042l-0.331 -0.248a0.6 0.6 0 0 0 0.166 -0.207q-0.188 -0.254 -0.207 -0.58a0.96 0.96 0 0 1 -0.29 0.373l0.166 0.083q-0.06 0.125 -0.042 0.29a2.8 2.8 0 0 1 -0.497 -0.083q-0.044 0.146 0.042 0.29 -0.05 0.118 -0.166 0.166a0.58 0.58 0 0 1 0.29 0.207q0.256 -0.076 0.207 -0.248 0.14 0.196 0.042 0.414l-0.083 -0.166q-0.272 0.342 -0.414 -0.083 -0.197 0.109 -0.248 0.331 -0.164 -0.314 -0.29 0 -0.005 -0.256 -0.166 -0.538 0.34 -0.13 0.373 -0.456 -0.228 -0.166 -0.124 0.042a0.58 0.58 0 0 0 -0.207 0.29l-0.166 -0.331q-0.141 0.212 -0.373 0.124l0.538 -0.456 0.331 0.166a3.32 3.32 0 0 1 0.538 -0.331q-0.124 -0.314 -0.207 0 -0.104 -0.288 -0.083 -0.58 0.214 0.3 0.538 0.166l-0.414 -0.166q0.136 -0.263 0.414 -0.373 -0.294 -0.25 -0.662 -0.248 0.411 0.191 0.124 0.538 -0.148 -0.184 -0.124 -0.331 -0.153 0.143 0 0.29 -0.118 0.077 -0.207 -0.042l-0.166 0.331q-0.062 -0.145 -0.207 -0.207 -0.209 -0.004 -0.373 -0.042 -0.062 0.191 0.042 0.373 -0.094 0.384 -0.29 0.042 -0.092 0.142 -0.207 0l-0.621 0.58q-0.05 -0.028 -0.042 -0.083 1.96 -2.099 4.555 -3.354a73.2 73.2 0 0 1 9.275 -3.727 39.6 39.6 0 0 0 3.727 -1.905q1.208 -0.835 2.195 -1.946 1.354 -1.714 1.449 -3.892z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#47a7e9",
    d: "M30.269 2.36q0.11 -0.158 0.248 0 -0.016 0.075 -0.083 0.083 -0.042 -0.104 -0.166 -0.083"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4fb3ec",
    d: "M12.132 2.36q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#3ca0ea",
    d: "m30.932 2.857 0.414 0.166q0.204 0.121 0.331 0.331v0.083l-0.248 -0.166q-0.294 -0.148 -0.497 -0.414"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#46a7e6",
    d: "M31.346 2.94q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#46bffa",
    d: "m31.428 3.271 0.248 0.166a5.2 5.2 0 0 1 0.29 1.077 26 26 0 0 1 0.042 2.07 78.4 78.4 0 0 0 -0.207 -2.319q-0.034 -0.578 -0.456 -0.952 0.028 -0.05 0.083 -0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#4fb2e7",
    d: "M10.145 3.934q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#45b9f9",
    d: "M23.313 0.373q-0.546 0.733 -1.242 1.366a29.08 29.08 0 0 1 -3.892 2.567 167.2 167.2 0 0 0 -6.294 3.147 36.8 36.8 0 0 0 -3.478 2.319Q5.276 12.34 3.851 16.108a26 26 0 0 1 0.248 -1.615q-0.004 -0.133 -0.083 -0.207a56.4 56.4 0 0 0 0.497 -2.07q0.156 -0.808 0.58 -1.491a14 14 0 0 0 0.911 -1.822 13.2 13.2 0 0 1 0.662 -1.242 11.6 11.6 0 0 0 0.828 -1.077 28 28 0 0 0 1.408 -1.574 0.54 0.54 0 0 0 0.248 -0.248q0.324 -0.117 0.497 -0.414a1.38 1.38 0 0 0 0.497 -0.414q1.958 -1.559 4.306 -2.484a55.6 55.6 0 0 1 2.816 -0.87Q20.074 -0.068 22.94 0.207q0.247 0.008 0.373 0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4eb2eb",
    d: "M9.648 4.348q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#52b3e8",
    d: "M9.151 4.762q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#2999f5",
    d: "M31.677 3.354q2.236 1.45 3.727 3.644 -0.107 -0.12 -0.166 0 1.554 4.465 -1.035 8.447a15.4 15.4 0 0 1 -2.443 2.567q-3.091 2.032 -6.708 2.94a342.8 342.8 0 0 1 -5.963 1.408q-3.18 0.927 -5.797 2.898 -3.279 3.044 -1.656 7.164a17.72 17.72 0 0 1 -2.816 -2.153 0.544 0.544 0 0 0 -0.248 -0.248l-1.408 -1.656 -0.083 -0.166q0.038 -0.081 0.083 -0.166 -0.162 -0.242 -0.248 -0.497 -0.632 -3.819 1.988 -6.625a6 6 0 0 1 0.58 -0.621q3.059 -2.503 6.874 -3.644a185.2 185.2 0 0 0 8.778 -2.733 21.2 21.2 0 0 0 2.733 -1.408q3.375 -2.05 4.141 -5.921a26 26 0 0 0 -0.042 -2.07 5.2 5.2 0 0 0 -0.29 -1.077z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4bb0ea",
    d: "M8.903 5.01q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#53b4ec",
    d: "M7.495 6.584q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3296e6",
    d: "M35.404 6.998q0.219 0.095 0.248 0.331 -0.219 -0.095 -0.248 -0.331"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3194e4",
    d: "M35.652 7.329q0.175 0.059 0.166 0.248 -0.175 -0.059 -0.166 -0.248"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4fb1e8",
    d: "M6.667 7.66q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#52b0e7",
    d: "M6.087 7.66q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#52afe8",
    d: "M6.584 7.66q-0.083 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#369ae4",
    d: "M35.818 7.578q0.219 0.095 0.248 0.331 -0.219 -0.095 -0.248 -0.331"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#40b4f7",
    d: "M35.404 6.998q0.03 0.236 0.248 0.331 -0.009 0.19 0.166 0.248 0.03 0.236 0.248 0.331l0.331 0.331 0.58 1.16a5.48 5.48 0 0 0 0.662 1.408q0.223 0.239 0.248 0.58a33.2 33.2 0 0 1 0.828 3.147q-0.387 6.741 -6.294 9.938l-0.124 -0.497q-0.038 0.286 -0.207 0.538l-0.58 0.207q-0.3 -0.027 -0.248 -0.331 -0.44 0.038 -0.331 -0.331l-0.166 -0.083q0.011 -0.274 0 -0.538 -0.331 -0.083 0 -0.166 -0.194 -0.04 -0.29 -0.207l-0.124 0.124q0.148 0.242 0 0.497 0.05 0.118 0.166 0.166 -0.501 0.274 0.042 0.124 0.206 0.33 0.414 0.662a0.36 0.36 0 0 1 0.124 -0.166q-0.055 0.18 0.166 0.29a0.96 0.96 0 0 1 -0.166 0.207q-0.148 -0.043 0 -0.124a1.28 1.28 0 0 1 -0.373 -0.124 0.56 0.56 0 0 1 -0.124 0.248 0.56 0.56 0 0 0 -0.331 -0.083q0.021 -0.164 -0.083 -0.29l0.166 -0.083 -0.497 -0.166a2.4 2.4 0 0 0 0.331 -0.414q-0.441 -0.315 -0.911 -0.373 0.134 -0.254 0.414 -0.331 0.042 0.187 0 0.331a1.32 1.32 0 0 0 0.414 -0.207q0.03 -0.318 -0.248 -0.58 0.061 -0.197 0.248 -0.29l-0.414 -0.166q0.278 -0.078 0.414 -0.331 -0.043 -0.148 -0.124 0a0.92 0.92 0 0 0 -0.124 -0.29l0.083 -0.083q-0.179 -0.097 -0.331 0.042 0.043 0.148 0.124 0 0.083 0.124 0 0.248 -0.303 -0.19 -0.497 -0.497l-0.207 0.207q0.235 0.134 0.083 0.331 0.331 0.083 0 0.166h0.497q-0.356 0.169 -0.497 0.538 0.117 -0.002 0.166 0.124 -0.204 0.036 -0.331 0.331l0.166 0.248q-0.104 0.126 -0.083 0.29 -0.164 0.021 -0.29 -0.083 -0.112 0.339 0.166 0.166 0.132 0.016 0.207 0.124a0.96 0.96 0 0 0 -0.373 0.29q-0.185 -0.094 -0.042 -0.207 -0.584 0.114 -0.083 -0.248 -0.126 -0.13 -0.042 -0.29 0.089 0.118 0.207 0.042 -0.422 -0.46 -0.248 -1.035a0.408 0.408 0 0 1 0.248 0.042q-0.355 0.471 0.207 0.373 0.083 -0.124 0 -0.248 -0.276 -0.276 -0.331 -0.662l-0.083 0.248q-0.047 -0.316 -0.207 -0.58 0.161 -0.815 -0.29 -0.166 -0.063 -0.186 0.124 -0.29l-0.166 -0.083 0.662 -0.497q-0.119 -0.142 0.083 -0.248l-0.166 -0.331q0.447 -0.368 0.994 -0.538 0.136 0.48 0.207 0 0.192 0.343 0.29 -0.042 0.118 -0.077 0.207 0.042 0.188 -0.317 0.207 0.083 0.385 0.011 0.083 -0.124 0.166 -0.083 0 -0.166l0.248 -0.083q-0.742 -0.094 -0.083 -0.373 0.118 0.102 0.248 0.042l-0.083 -0.083a10.4 10.4 0 0 0 0.828 -0.704 15.4 15.4 0 0 0 2.443 -2.567q2.59 -3.982 1.035 -8.447 0.058 -0.12 0.166 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#47a5e5",
    d: "M36.398 8.157q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#43a9eb",
    d: "M6.004 8.903a14 14 0 0 1 -0.911 1.822l0.414 -1.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#51b0e7",
    d: "M5.507 9.565q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.173
    },
    fill: "#3a9ee5",
    d: "M36.977 9.4a5.48 5.48 0 0 1 0.662 1.408 5.48 5.48 0 0 1 -0.662 -1.408"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.349
    },
    fill: "#3c9de5",
    d: "M37.888 11.387q0.627 1.468 0.911 3.064 -0.083 0 -0.083 0.083a33.2 33.2 0 0 0 -0.828 -3.147"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#4aaae7",
    d: "M38.468 12.629q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#44a3e5",
    d: "M4.514 12.215a56.4 56.4 0 0 1 -0.497 2.07q-0.08 0.646 -0.248 1.242 0.153 -1.719 0.745 -3.313"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#4dbffa",
    d: "M4.016 14.286q0.079 0.074 0.083 0.207a26 26 0 0 0 -0.248 1.615q-0.056 0.455 -0.124 0.911a4.16 4.16 0 0 1 -0.042 -0.828q-0.038 -0.358 0.083 -0.662 0.169 -0.597 0.248 -1.242"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#48a6e8",
    d: "M38.965 14.866q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4aa7e5",
    d: "M3.52 15.528q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#41b4f7",
    d: "M8.903 20.911q-2.619 2.807 -1.988 6.625 0.046 0.31 -0.166 0.166 -0.685 -0.77 -1.077 -1.739a5.68 5.68 0 0 0 -0.58 -1.16 3.92 3.92 0 0 1 -0.414 -0.828q0.074 -0.029 0.083 -0.124a10.4 10.4 0 0 0 -0.248 -0.704 6 6 0 0 1 -0.042 -1.656 16 16 0 0 1 0.456 -1.988q0.787 -1.74 2.07 -3.147 -0.008 0.054 0.042 0.083l0.621 -0.58q0.115 0.142 0.207 0 0.196 0.342 0.29 -0.042 -0.103 -0.182 -0.042 -0.373 0.164 0.037 0.373 0.042 0.145 0.062 0.207 0.207l0.166 -0.331q0.089 0.118 0.207 0.042 -0.153 -0.147 0 -0.29 -0.024 0.148 0.124 0.331 0.286 -0.347 -0.124 -0.538 0.368 -0.001 0.662 0.248 -0.278 0.109 -0.414 0.373l0.414 0.166q-0.324 0.134 -0.538 -0.166 -0.021 0.291 0.083 0.58 0.083 -0.314 0.207 0a3.32 3.32 0 0 0 -0.538 0.331l-0.331 -0.166 -0.538 0.456q0.232 0.088 0.373 -0.124l0.166 0.331a0.58 0.58 0 0 1 0.207 -0.29q-0.104 -0.207 0.124 -0.042 -0.032 0.325 -0.373 0.456 0.16 0.282 0.166 0.538 0.126 -0.314 0.29 0 0.052 -0.222 0.248 -0.331 0.142 0.424 0.414 0.083l0.083 0.166q0.099 -0.218 -0.042 -0.414 0.049 0.173 -0.207 0.248a0.58 0.58 0 0 0 -0.29 -0.207q0.115 -0.048 0.166 -0.166 -0.085 -0.144 -0.042 -0.29 0.252 0.064 0.497 0.083 -0.018 -0.165 0.042 -0.29l-0.166 -0.083a0.96 0.96 0 0 0 0.29 -0.373q0.019 0.325 0.207 0.58a0.6 0.6 0 0 1 -0.166 0.207l0.331 0.248q-0.118 0.077 -0.207 -0.042l-0.083 0.166q-0.04 -0.224 -0.166 -0.083a6.4 6.4 0 0 1 -0.042 0.662 1.36 1.36 0 0 0 0.166 0.373q-0.016 0.132 -0.124 0.207 -0.185 -0.086 -0.373 0.083 0.197 0.015 0.414 0.207a0.6 0.6 0 0 0 -0.166 0.207q0.043 0.148 0.124 0 -0.018 0.244 0.042 0.456 -0.044 0.156 -0.166 0.083 -0.082 -0.185 -0.248 -0.29 -0.116 0.433 -0.497 0.373l0.248 0.414 -0.166 0.083 0.248 0.248q-0.337 0.386 -0.662 0.58 0.068 0.089 0.166 0.124"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#4aa6e4",
    d: "M3.52 15.942q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#4aa5e3",
    d: "M3.437 16.273q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#47a4e6",
    d: "M39.13 16.273q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#2898f5",
    d: "M38.799 14.451q1.301 7.428 -3.023 13.582a12.8 12.8 0 0 1 -0.787 0.911q-0.039 -0.122 -0.166 -0.166 -0.115 0.142 -0.207 0 -0.088 0.232 0.124 0.373a2.96 2.96 0 0 0 -0.745 0.248q-0.094 0.083 -0.083 0.207a67.6 67.6 0 0 1 -2.898 1.325 813.6 813.6 0 0 1 -7.868 2.36q-1.326 0.434 -2.153 1.532 -0.219 0.095 -0.248 0.331 -0.814 0.234 -1.366 -0.166l-0.083 0.083q-0.061 -0.13 0.042 -0.248 -0.246 -0.15 -0.497 0a14 14 0 0 1 -0.621 -0.166 81.2 81.2 0 0 0 -1.201 0.166 9.6 9.6 0 0 1 -1.656 -0.497v-0.083q-0.13 -2.248 1.574 -3.768 1.372 -1.059 2.981 -1.739a117.2 117.2 0 0 0 2.898 -0.994 67.6 67.6 0 0 0 8.033 -2.484l1.574 -0.787q5.907 -3.197 6.294 -9.938 0 -0.083 0.083 -0.083"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#46a1e4",
    d: "M3.437 18.923q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3e9feb",
    d: "M39.13 19.255q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#47a1e3",
    d: "M3.52 19.917q0.127 0.049 0.042 0.166a0.2 0.2 0 0 1 -0.042 -0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#2b94f1",
    d: "M4.928 19.503a16 16 0 0 0 -0.456 1.988 6 6 0 0 0 0.042 1.656q0 0.083 -0.083 0.083a13.36 13.36 0 0 1 -0.745 -3.644q-0.02 -0.211 0.042 -0.414l0.083 0.166q0.038 -0.157 0.124 -0.29 -0.146 -0.386 0.124 -0.042 0.09 0.593 0.083 1.16a0.32 0.32 0 0 0 0.166 0.083q0.162 -0.15 0.373 -0.166 -0.004 -0.368 0.248 -0.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#45a4e7",
    d: "M3.768 21.325q0.127 0.049 0.042 0.166a0.2 0.2 0 0 1 -0.042 -0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#44a1e3",
    d: "M4.099 22.733q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#40b5f7",
    d: "M31.76 18.012a10.4 10.4 0 0 1 -0.828 0.704l0.083 0.083q-0.13 0.061 -0.248 -0.042 -0.659 0.279 0.083 0.373l-0.248 0.083q0.166 0.083 0 0.166 0.302 0.135 -0.083 0.124 -0.019 -0.4 -0.207 -0.083 -0.089 -0.118 -0.207 -0.042 -0.098 0.385 -0.29 0.042 -0.071 0.48 -0.207 0 -0.547 0.17 -0.994 0.538l0.166 0.331q-0.202 0.106 -0.083 0.248l-0.662 0.497 0.166 0.083q-0.187 0.104 -0.124 0.29 0.451 -0.65 0.29 0.166 0.16 0.264 0.207 0.58l0.083 -0.248q0.055 0.386 0.331 0.662 0.083 0.124 0 0.248 -0.562 0.098 -0.207 -0.373a0.408 0.408 0 0 0 -0.248 -0.042q-0.173 0.576 0.248 1.035 -0.118 0.077 -0.207 -0.042 -0.085 0.16 0.042 0.29 -0.502 0.362 0.083 0.248 -0.143 0.114 0.042 0.207a0.96 0.96 0 0 1 0.373 -0.29q-0.076 -0.108 -0.207 -0.124 -0.278 0.174 -0.166 -0.166 0.126 0.104 0.29 0.083 -0.021 -0.164 0.083 -0.29l-0.166 -0.248q0.127 -0.296 0.331 -0.331 -0.049 -0.126 -0.166 -0.124 0.141 -0.369 0.497 -0.538h-0.497q0.331 -0.083 0 -0.166 0.152 -0.197 -0.083 -0.331l0.207 -0.207q0.194 0.307 0.497 0.497 0.083 -0.124 0 -0.248 -0.081 0.148 -0.124 0 0.152 -0.138 0.331 -0.042l-0.083 0.083a0.92 0.92 0 0 1 0.124 0.29q0.081 -0.148 0.124 0 -0.136 0.253 -0.414 0.331l0.414 0.166q-0.188 0.093 -0.248 0.29 0.278 0.262 0.248 0.58a1.32 1.32 0 0 1 -0.414 0.207q0.042 -0.144 0 -0.331 -0.28 0.078 -0.414 0.331 0.47 0.058 0.911 0.373a2.4 2.4 0 0 1 -0.331 0.414l0.497 0.166 -0.166 0.083q0.104 0.126 0.083 0.29a0.56 0.56 0 0 1 0.331 0.083 0.56 0.56 0 0 0 0.124 -0.248 1.28 1.28 0 0 0 0.373 0.124q-0.148 0.081 0 0.124a0.96 0.96 0 0 0 0.166 -0.207q-0.22 -0.109 -0.166 -0.29a0.36 0.36 0 0 0 -0.124 0.166l-0.414 -0.662q-0.542 0.15 -0.042 -0.124 -0.115 -0.048 -0.166 -0.166 0.148 -0.255 0 -0.497l0.124 -0.124q0.096 0.168 0.29 0.207 -0.331 0.083 0 0.166 0.011 0.264 0 0.538l0.166 0.083q-0.108 0.369 0.331 0.331 -0.052 0.304 0.248 0.331l0.58 -0.207q0.169 -0.252 0.207 -0.538l0.124 0.497 -1.574 0.787a67.6 67.6 0 0 1 -8.033 2.484 117.2 117.2 0 0 1 -2.898 0.994q-1.609 0.68 -2.981 1.739 -1.703 1.52 -1.574 3.768a40.8 40.8 0 0 1 -3.147 -1.491 2.72 2.72 0 0 1 -0.58 -0.248v-0.083q-1.623 -4.12 1.656 -7.164 2.618 -1.971 5.797 -2.898a342.8 342.8 0 0 0 5.963 -1.408q3.618 -0.908 6.708 -2.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3798e5",
    d: "M4.514 23.147a10.4 10.4 0 0 1 0.248 0.704q-0.009 0.095 -0.083 0.124a6 6 0 0 0 -0.248 -0.745q0.083 0 0.083 -0.083"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#47a3e3",
    d: "M4.762 24.886q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#46a5e4",
    d: "M4.928 25.052q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#3b9de7",
    d: "M5.093 24.803a5.68 5.68 0 0 1 0.58 1.16q-0.419 -0.507 -0.58 -1.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#48a4e7",
    d: "M5.673 26.377q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#46a4e6",
    d: "M6.087 27.039q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3b9fed",
    d: "M36.315 27.371q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#37a3f2",
    d: "M6.915 27.536q0.087 0.256 0.248 0.497 -0.045 0.085 -0.083 0.166a1.52 1.52 0 0 1 -0.331 -0.497q0.212 0.144 0.166 -0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42a1eb",
    d: "M7.164 28.364q-0.083 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#258df0",
    d: "M34.99 28.944a7.2 7.2 0 0 1 -0.828 0.994q-0.138 -0.098 -0.331 -0.124l0.331 -0.166a0.408 0.408 0 0 0 -0.248 -0.042q-0.011 -0.124 0.083 -0.207a2.96 2.96 0 0 1 0.745 -0.248q-0.212 -0.141 -0.124 -0.373 0.092 0.142 0.207 0 0.127 0.044 0.166 0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#1b85ef",
    d: "M33.913 29.607a0.408 0.408 0 0 1 0.248 0.042l-0.331 0.166q0.194 0.026 0.331 0.124 -5.61 5.819 -13.748 5.466 0.223 -0.1 0.497 -0.124 -0.114 -0.034 -0.166 -0.124 0.03 -0.236 0.248 -0.331 0.197 -0.114 0.373 0l0.166 -0.166q0.195 0.021 0.456 0.083 -0.038 -0.242 0 -0.414 0.22 0.164 0.083 0.373 0.269 0.053 0.497 -0.124a0.572 0.572 0 0 0 0.331 0.166q0.349 -0.066 0.662 0 0.312 -0.21 0.373 -0.58l0.083 0.083q0.181 -0.239 0.414 -0.166 0.257 -0.424 0.29 0 0.372 -0.042 0.745 0a0.76 0.76 0 0 1 0.207 -0.166q0.221 0.167 0.248 0.331 0.348 0.041 0.704 -0.124a0.696 0.696 0 0 0 -0.331 -0.042q-0.005 -0.546 0.124 -0.083 0.214 -0.26 0.29 -0.58 0.244 -0.03 0.456 0.083 0.268 -0.203 0.621 -0.124l-0.083 -0.083q0.479 -0.158 0.828 -0.497a0.32 0.32 0 0 0 -0.083 -0.166 0.36 0.36 0 0 0 0.166 -0.124q-0.192 -0.335 0.166 -0.497a0.6 0.6 0 0 1 0.207 0.166q0.088 -0.232 -0.124 -0.373 0.118 -0.077 0.207 0.042a0.8 0.8 0 0 1 0.207 -0.124l-0.083 -0.083a10 10 0 0 0 0.621 -0.207q0.126 0.141 0.166 -0.083l0.083 0.083a19.2 19.2 0 0 0 0.952 -0.497 67.6 67.6 0 0 0 2.898 -1.325"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#41a2e9",
    d: "M8.572 30.021q-0.083 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#41a3eb",
    d: "M8.82 30.269q-0.083 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#44a4f0",
    d: "M9.4 30.932q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#55baf0",
    d: "M37.971 32.091q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#49abee",
    d: "M11.387 32.422q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#46acee",
    d: "M11.636 32.505q-0.083 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#4cb1ec",
    d: "m39.793 32.588 0.166 0.083v0.994a3.4 3.4 0 0 1 -0.58 1.077q0.26 -0.563 0.456 -1.16a2.32 2.32 0 0 0 -0.042 -0.994"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#56baf0",
    d: "M36.066 33.499q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#3da6f0",
    d: "M12.215 32.754a40.8 40.8 0 0 0 3.147 1.491v0.083q-1.682 -0.593 -3.147 -1.574"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#1783ef",
    d: "M31.014 30.932a19.2 19.2 0 0 1 -0.952 0.497l-0.083 -0.083q-0.04 0.224 -0.166 0.083a10 10 0 0 1 -0.621 0.207l0.083 0.083a0.8 0.8 0 0 0 -0.207 0.124q-0.089 -0.118 -0.207 -0.042 0.212 0.141 0.124 0.373a0.6 0.6 0 0 0 -0.207 -0.166q-0.358 0.162 -0.166 0.497a0.36 0.36 0 0 1 -0.166 0.124 0.32 0.32 0 0 1 0.083 0.166q-0.349 0.339 -0.828 0.497l0.083 0.083q-0.353 -0.078 -0.621 0.124 -0.211 -0.112 -0.456 -0.083 -0.075 0.32 -0.29 0.58 -0.13 -0.463 -0.124 0.083a0.696 0.696 0 0 1 0.331 0.042q-0.355 0.165 -0.704 0.124 -0.028 -0.164 -0.248 -0.331a0.76 0.76 0 0 0 -0.207 0.166 3.28 3.28 0 0 0 -0.745 0q-0.032 -0.424 -0.29 0 -0.233 -0.073 -0.414 0.166l-0.083 -0.083q-0.061 0.37 -0.373 0.58 -0.314 -0.066 -0.662 0a0.572 0.572 0 0 1 -0.331 -0.166q-0.228 0.178 -0.497 0.124 0.137 -0.209 -0.083 -0.373 -0.038 0.172 0 0.414 -0.26 -0.062 -0.456 -0.083l-0.166 0.166q-0.176 -0.114 -0.373 0 0.827 -1.098 2.153 -1.532a813.6 813.6 0 0 0 7.868 -2.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4cb3f0",
    d: "M13.54 33.664q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#4ec0fb",
    d: "M39.793 32.588a2.32 2.32 0 0 1 0.042 0.994 10.8 10.8 0 0 1 -0.456 1.16q-2.675 4.686 -6.46 8.572a42.4 42.4 0 0 1 -2.981 2.526q-2.277 1.469 -4.886 2.278a8.48 8.48 0 0 1 -1.988 0.373q-1.864 0.021 -3.727 -0.042a34.8 34.8 0 0 1 -3.975 -0.787l-1.905 -0.497q-1.236 -0.494 -2.567 -0.745 -0.203 -0.109 -0.456 -0.166 -0.143 0.25 -0.29 0.042l0.083 -0.083a39.2 39.2 0 0 0 -2.484 -0.373q-0.238 -0.095 -0.828 -0.083 -1.941 -0.001 -3.727 0.662a30.8 30.8 0 0 1 -2.112 0.58q-0.814 -0.022 -1.118 -0.745v-1.077q0.707 -2.74 2.236 -5.134a22.6 22.6 0 0 1 2.65 -2.981q1.52 -1.153 3.396 -1.574 3.044 -0.25 6.004 0.662 0.095 -0.009 0.124 -0.083a1.72 1.72 0 0 0 0.414 0.083q0.088 0.112 0.248 0.083 2.498 0.986 5.217 1.242l1.16 0.166q0.49 0.148 1.988 0.042a74.8 74.8 0 0 0 1.739 -0.248q0.324 -0.048 0.58 -0.207 1.079 -0.423 2.236 -0.331 1.066 0.756 0.373 1.905a5.92 5.92 0 0 1 -0.952 1.077q-2.532 1.596 -5.549 1.698l-4.224 0.083q-0.15 0.138 0.083 0.124 0.497 0.262 1.077 0.331 5.15 1.47 9.855 -1.118a30.8 30.8 0 0 0 2.567 -2.029 8.96 8.96 0 0 0 1.408 -1.491 1.6 1.6 0 0 0 0.248 -0.414 145.2 145.2 0 0 0 3.23 -3.561q1.031 -0.967 2.402 -1.366 0.508 -0.095 0.994 0.083 0.28 0.093 0.331 0.373"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#2991f1",
    d: "M20.745 35.155q0.052 0.09 0.166 0.124 -0.274 0.024 -0.497 0.124a14.56 14.56 0 0 1 -3.396 -0.58 81.2 81.2 0 0 1 1.201 -0.166q0.306 0.089 0.621 0.166 0.25 -0.15 0.497 0 -0.102 0.118 -0.042 0.248l0.083 -0.083q0.552 0.399 1.366 0.166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43a8f3",
    d: "M18.344 35.238q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#44a7f2",
    d: "M18.675 35.321q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#44a6f1",
    d: "M18.923 35.321q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#55bcf5",
    d: "M12.381 35.404q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#58bdf4",
    d: "M7.412 35.486q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#57bef4",
    d: "M7.578 35.486q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4db6f3",
    d: "M14.368 36.066q-0.029 0.074 -0.124 0.083 -2.96 -0.912 -6.004 -0.662 3.164 -0.412 6.128 0.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#56bff9",
    d: "M12.712 35.486q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#58bff7",
    d: "M13.54 35.652q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#56c0f7",
    d: "M14.783 36.066q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#54bef6",
    d: "M15.031 36.149q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#53b8f6",
    d: "M27.95 36.812q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#53b9f3",
    d: "M28.116 36.812q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#56beee",
    d: "M4.845 37.06q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#58c3f9",
    d: "M32.836 37.06q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#54c0f9",
    d: "M20.248 37.391q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#54bef4",
    d: "M20.414 37.474q0.093 -0.133 0.248 -0.042a0.408 0.408 0 0 1 -0.248 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#52bbf3",
    d: "M23.064 37.391q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#50bbf6",
    d: "M23.396 37.474q0.093 -0.133 0.248 -0.042a0.408 0.408 0 0 1 -0.248 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#53bcf5",
    d: "M21.905 37.474q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#53bcf7",
    d: "M22.153 37.557q0.093 -0.133 0.248 -0.042a0.408 0.408 0 0 1 -0.248 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#47b0f1",
    d: "M25.714 37.226q-0.256 0.158 -0.58 0.207a74.8 74.8 0 0 1 -1.739 0.248q-1.497 0.107 -1.988 -0.042a23.32 23.32 0 0 0 4.306 -0.414"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#57c0f7",
    d: "M32.091 37.64q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#4bb3f1",
    d: "M32.588 37.474a8.96 8.96 0 0 1 -1.408 1.491 8.96 8.96 0 0 1 1.408 -1.491"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59bbed",
    d: "M2.278 39.71q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#59c1f8",
    d: "M27.536 39.793q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#57bff5",
    d: "M27.371 39.876q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59bbed",
    d: "M2.195 40.042q-0.083 -0.166 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#55c1f8",
    d: "M26.377 40.538q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5cc4f8",
    d: "M28.447 40.87q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5abdee",
    d: "M1.449 40.952q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59c3f6",
    d: "M24.969 41.118q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#55c4f6",
    d: "M24.555 41.201q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#57c2f6",
    d: "M24.555 41.284q-0.049 0.127 -0.166 0.042a0.2 0.2 0 0 1 0.166 -0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#57c4f8",
    d: "M17.681 41.78q0.049 -0.127 0.166 -0.042a0.2 0.2 0 0 1 -0.166 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#58c3fa",
    d: "M17.93 41.698q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59c3f7",
    d: "M21.077 41.698q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#58c4f8",
    d: "M18.758 42.112q0.049 -0.127 0.166 -0.042a0.2 0.2 0 0 1 -0.166 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59c2f8",
    d: "M19.255 42.112q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59c5fa",
    d: "M19.503 42.195q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#5abced",
    d: "M0.787 42.278q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#5bc4f7",
    d: "M23.313 42.443q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#56b6e7",
    d: "M0.124 43.934q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#59b9ec",
    d: "M29.938 45.838q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#4ab3ef",
    d: "M7.743 45.838a147.2 147.2 0 0 1 -2.898 0.207l-1.656 0.373q1.786 -0.664 3.727 -0.662 0.59 -0.012 0.828 0.083"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#56bcf1",
    d: "M7.081 46.004q0.049 -0.127 0.166 -0.042a0.2 0.2 0 0 1 -0.166 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#55b9f0",
    d: "M7.412 46.004q0.049 -0.127 0.166 -0.042a0.2 0.2 0 0 1 -0.166 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#57baef",
    d: "M3.52 46.418q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#58bdf2",
    d: "M10.89 46.418q-0.083 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#54bdf2",
    d: "M10.973 46.501q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#57b9ee",
    d: "M12.961 47.081q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#53bcf0",
    d: "M13.458 47.164v0.083q-0.083 -0.06 0 -0.083"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#53b9ee",
    d: "M13.458 47.246q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5ab8ea",
    d: "M25.217 48.157q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.933
    },
    fill: "#4ab3ef",
    d: "M15.362 47.66a34.8 34.8 0 0 0 3.975 0.787q1.863 0.062 3.727 0.042v0.083q-0.481 -0.039 -0.911 0.083h-1.905a21.32 21.32 0 0 1 -4.886 -0.994"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#56baed",
    d: "M18.012 48.489q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#53b9ed",
    d: "M18.261 48.572q0.049 -0.127 0.166 -0.042a0.2 0.2 0 0 1 -0.166 0.042"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#55b7ea",
    d: "M23.727 48.489q0.166 0.083 0 0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#53b5ec",
    d: "M18.675 48.654q0.083 -0.166 0.166 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#53b7eb",
    d: "M18.923 48.654q0.124 -0.166 0.248 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#54b8ed",
    d: "M23.064 48.572q0.083 0 0.083 0.083z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWafynetLogo);
export default __webpack_public_path__ + "static/media/wafynetLogo.bf33ac5789cc339efd270dbcbf98a583.svg";
export { ForwardRef as ReactComponent };